import cleanParagraphs from './core-modules/cleanParagraphs';
import removeBreakTags from './core-modules/removeBreakTags';
import initNavbar from './internal-modules/navbar';
import initFloatingButtons from './internal-modules/floating-buttons';
import initScrollEffects from './internal-modules/scroll-effects';
import initMenuDigital from './internal-modules/menu-digital';
import initVibeModal from './internal-modules/vibe-modal';
import initAboutReadMore from './internal-modules/about-read-more';
import initServicesModal from './internal-modules/services-modal';
import initPwaInstall from './internal-modules/pwa-install';

(() => {
    cleanParagraphs();
    removeBreakTags();

    document.addEventListener('DOMContentLoaded', () => {
        initNavbar();
        initFloatingButtons();
        initScrollEffects();
        initVibeModal();
        initAboutReadMore();
        initServicesModal();
    });

    // Execute immediately as it uses Event Delegation
    initMenuDigital();

    // Script carga en el footer: el popup ya existe y no perdemos beforeinstallprompt
    initPwaInstall();
})();
